import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
import Cookie from "js-cookie";

import router from "@/router";

// create an axios instance
let service = axios.create({
  baseURL: "/api", // api 的 base_url
  timeout: 600 * 1000 // request timeout
});

let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;
let removePending = ever => {
  for (let p in pending) {
    if (pending[p].u === ever.url + "&" + ever.method) {
      //当当前请求在数组中存在时执行函数体
      pending[p].f(); //执行取消操作
      pending.splice(p, 1); //把这条记录从数组中移除
    }
  }
};

// request interceptor
service.interceptors.request.use(
  config => {
    // console.log(config)

    // if (config.url.indexOf('findHandleOpinion') >= 0) {
    //   if (window.sessionStorage.ajaxNum) {
    //     return false
    //   }
    //   window.sessionStorage.ajaxNum = '1'
    //   setTimeout(() => {
    //     window.sessionStorage.ajaxNum = ''
    //   }, 200)
    // }

    let Token = window.localStorage.Token;
    // Basic d2ViLWFwcDpycTludU5rSXdU
    if (!Token || Token == "d2ViLWFwcDpycTludU5rSXdU") {
      config.headers["Authorization"] = "Basic d2ViLWFwcDpycTludU5rSXdU";
    } else {
      config.headers["Authorization"] = "Bearer " + Token;
    }

    // -------------------------------------------------------------------------
    // if (config.url.indexOf('findHandleOpinion') >= 0) {
    //   removePending(config); //在一个ajax发送前执行一下取消操作
    //   config.cancelToken = new cancelToken((c) => {
    //     // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
    //     pending.push({ u: config.url + '&' + config.method, f: c });
    //   });
    // }

    // -------------------------------------------------------------------------------

    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    let url = response.config.url
    if (url.indexOf('/api/learn/api') >=0) {
      const res = response.data
      if (res.code == 500) {
        Message({
          type: 'warning',
          message: res.msg,
        })
      }
      return response
    } else {
      return response
    }
  },

  error => {
    let code = error.response.data.code;
    if (code == 306) {
      Cookie.set("resCode", 306);
      window.localStorage.Token = "";
      router.push("/login");
      return Promise.reject("error");
    } else if (code == 401) {
      Cookie.set("resCode", 401);
      window.localStorage.Token = "";
      router.push("/login");
    } else if (
      Object.prototype.toString.apply(error.response.data).indexOf("String") >=
      0
    ) {
      return Promise.reject(error);
    } else {
      Message({
        message: "服务器错误，请联系系统管理员",
        type: "error"
        // duration: 5 * 1000
      });
      return Promise.reject(error);
      // return false
    }
  }
);

export default service;
